import React from 'react';
import { makeStyles } from 'react-scale/components/ui/styles';
import classnames from 'classnames';

const AuditDiffSelectNav: React.FC<{
  setView: (arg0: number) => void;
  views: string[];
  view: number;
}> = ({ setView, views, view }) => {
  const classes = useStyles();

  return (
    <div className={classes.auditDiffSelectNav}>
      {views.map((v, i: number) => (
        <div className={classnames({ isActive: view === i })} key={i} onClick={() => setView(i)}>
          {v}
        </div>
      ))}
    </div>
  );
};

const useStyles = makeStyles({
  auditDiffSelectNav: () => ({
    overflow: 'hidden',
    background: 'white',
    borderBottom: '1px solid var(--color-RemoGray01)',
    fontSize: '15px',

    flexshrink: '0',
    padding: '0',

    height: '52px',
    display: 'flex',
    alignItems: 'stretch',
    overflowX: 'auto',

    '& > div': {
      position: 'relative',
      marginRight: '12px',
      padding: '0 16px',
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      '&.isActive': {
        fontWeight: 'bold',
      },
    },
  }),
});

export default AuditDiffSelectNav;
